import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { LoaderService } from '@services/support/loader.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-nova-iframe',
    templateUrl: './nova-iframe.component.html',
    styleUrls: ['./nova-iframe.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NovaIframeComponent implements OnInit, OnDestroy {

  @ViewChild('frame', {static: false}) frame: ElementRef<HTMLIFrameElement>;

  iframeSrc: string = null;
  novaBaseUrl: string = environment.endPoints.novaBase; //'https://vsight.github.io';
  novaUrl: string = environment.endPoints.novaUrl; // 'https://vsight.github.io/vsight-nova-ai-chat';

  constructor(
    private authService: AuthService,
    private loaderService: LoaderService
  ){}

  ngOnInit(): void {
    this.loaderService.show()
    this.authService.refreshIdToken()
    .then(token => {
      if (token) {
        const env = environment.name === 'dev' ? 'dev' : 'prod'
        const origin = encodeURIComponent(window.location.origin)
        this.iframeSrc = `${this.novaUrl}?token=${token}&env=${env}&origin=${origin}`
      }
      this.loaderService.hide()
    })
    .catch(() => {
      this.loaderService.hide()
    })
  }

  ngOnDestroy(): void {
  }

  onFrameLoad() {
    // iFrame yüklendiğinde yapılacak işlemler varsa buraya ekleyin
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent<any>) {
    if (event.origin !== this.novaBaseUrl) return;

    if (event.data.authRequest && this.frame && this.frame.nativeElement) {
      this.authService.refreshIdToken().then(token => {
        if (token) {
          this.frame.nativeElement.contentWindow.postMessage({ authToken: token }, this.novaBaseUrl)
        }
      })
    }
  }
}
